<template>
    <div class="container outer-container">
        <div class="row">
            <div class="col main-title">
                <h1>{{ $t('title') }}</h1>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <investment-goals />
                <investment-strategy />
                <risk-tolerance-questions />
                <risk-tolerance-evaluation />
                <theme />
                <investment-proposal />
                <appointment />
            </div>
        </div>
    </div>
</template>

<script>
import InvestmentGoals from '@/components/InvestmentGoals';
import InvestmentStrategy from '@/components/InvestmentStrategy';
import Theme from '@/components/Theme';
import RiskToleranceQuestions from '@/components/RiskToleranceQuestions';
import RiskToleranceEvaluation from '@/components/RiskToleranceEvaluation';
import InvestmentProposal from '@/components/InvestmentProposal';
import Appointment from '@/components/Appointment';

export default {
    name: 'MainView',
    components: {
        InvestmentGoals,
        Theme,
        InvestmentStrategy,
        InvestmentProposal,
        RiskToleranceQuestions,
        RiskToleranceEvaluation,
        Appointment,
    },
};
</script>

<style lang="scss" scoped>
  .main-title {
    margin-left: 13px;
    @include media-breakpoint-down(xs) {
      position: relative;
      padding: 18px 10px 8px 15px;
      margin-left: 2px;

      h1 {
        line-height: 30px;
        margin-bottom: 10px;
      }
    }
  }
</style>
